import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { obtenerInventarioInicialUseCase } from "../../../core/inventarios/application/obtenerInventarioInicial.usecase.js";
import { crearInventarioInicialUseCase } from "../../../core/inventarios/application/registrarInventarioInicialPeriodo.usecase.js";
import { actualizarInventarioInicialUseCase } from "../../../core/inventarios/application/actualizarInventarioInicial.usecase.js";

const InventarioInicialContext = createContext(null);
export const useInventarioInicial = () => useContext(InventarioInicialContext);

export function InventarioInicialProvider({ children }) {
  const [periodos, setPeriodos] = useState([]);
  const [inventarioInicial, setInventarioInicial] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  // Lista inventario inicial completo
  // 🔹 Listar inventario completo

  const listarInventarioInicial = useCallback(async () => {
    try {
      setLoading(true);
      const data = await obtenerInventarioInicialUseCase();

      setInventarioInicial(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(
        "InventarioInicialContext Error listando inventario inicial:",
        error,
      );
      setMensaje(
        error.message || "InventarioInicialContext Error cargando inventario",
      );
      setInventarioInicial([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Función de creación de periodos (la dejamos tal cual)
  const CrearPeriodos = useCallback(async () => {
    setLoading(true);
    try {
      const data = await crearInventarioInicialUseCase();
      setPeriodos(data || []);
      console.log(
        "Callback [InventarioInicialContext] Periodos creados:",
        data,
      );
    } catch (error) {
      console.error(
        "Callback [InventarioInicialContext] Error creando periodos:",
        error,
      );
      setMensaje(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // Crear inventario inicial
const crearInventario = useCallback(
  async (periodoId) => {
    try {
      console.log("[crearInventario] periodoId recibido:", periodoId);

      // 🔹 Llamada al useCase que crea el inventario
      const resultado = await crearInventarioInicialUseCase(periodoId);

      // 🔹 Recarga periodos si quieres mantener consistencia
      await CrearPeriodos();

      setMensaje("Inventario inicial creado correctamente");

      return resultado;
    } catch (error) {
      console.error("[crearInventario] Error creando inventario:", error);
      setMensaje(error.message);
      return { success: false, error: error.message };
    }
  },
  [CrearPeriodos],
      [listarInventarioInicial],
);

  // Actualizar cantidad en inventario inicial
  // Esta función orquesta la actualización del stock y maneja la recarga de inventario.
  // Se recomienda capturar cualquier error aquí para facilitar debugging.
  // Se añaden logs detallados para seguimiento en consola.
  const actualizarCantidad = useCallback(
    async ({ idInventario, cantidad }) => {
      try {
        // Validación de entrada
        if (!idInventario) {
          throw new Error(
            "[InventarioInicialContext] idInventario inválido en actualizarCantidad",
          );
        }

        // Llamada al useCase que maneja la lógica de negocio
        const resultado = await actualizarInventarioInicialUseCase({
          idInventario,
          cantidad,
        });

        // 🔹 Log de éxito mejorado
        console.info(
          "[InventarioInicialContext] actualizarCantidad - operación exitosa ",
          {
            success: true,
            idInventario,
            cantidad,
            resultado,
            timestamp: new Date().toISOString(), // opcional, útil para auditoría
          },
        );

        // Recarga del inventario para mantener consistencia visual
        await listarInventarioInicial();

        return resultado;
      } catch (error) {
        // Log detallado para debugging
        console.error(
          "[InventarioInicialContext][Error] actualizarCantidad falló ",
          {
            success: false,
            idInventario,
            cantidad,
            message: error.message,
            stack: error.stack,
            timestamp: new Date().toISOString(),
          },
        );

        // Lanzar nuevamente el error para que el componente consumidor pueda reaccionar
        throw error;
      }
    },
    [listarInventarioInicial],
  );

  // Efecto inicial: cargar inventario completo al montar
  useEffect(() => {
    listarInventarioInicial();
  }, [listarInventarioInicial]);

  // Memorizar value
  const value = useMemo(
    () => ({
      periodos,
      inventarioInicial,
      loading,
      mensaje,
      CrearPeriodos,
      listarInventarioInicial,
      crearInventario,
      actualizarCantidad,
      setMensaje,
    }),
    [
      periodos,
      inventarioInicial,
      loading,
      mensaje,
      CrearPeriodos,
      listarInventarioInicial,
      crearInventario,
      actualizarCantidad,
    ],
  );

  return (
    <InventarioInicialContext.Provider value={value}>
      {children}
    </InventarioInicialContext.Provider>
  );
}
